/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateBatchJobResponse
 */
export interface CreateBatchJobResponse {
    /**
     * 
     * @type {number}
     * @memberof CreateBatchJobResponse
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof CreateBatchJobResponse
     */
    jobId: number;
    /**
     * 
     * @type {number}
     * @memberof CreateBatchJobResponse
     */
    clusterId?: number;
}

/**
 * Check if a given object implements the CreateBatchJobResponse interface.
 */
export function instanceOfCreateBatchJobResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "jobId" in value;

    return isInstance;
}

export function CreateBatchJobResponseFromJSON(json: any): CreateBatchJobResponse {
    return CreateBatchJobResponseFromJSONTyped(json, false);
}

export function CreateBatchJobResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateBatchJobResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'jobId': json['job_id'],
        'clusterId': !exists(json, 'cluster_id') ? undefined : json['cluster_id'],
    };
}

export function CreateBatchJobResponseToJSON(value?: CreateBatchJobResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'job_id': value.jobId,
        'cluster_id': value.clusterId,
    };
}

